const months = [
  {
    label: "Ocak",
    value: "01",
  },
  {
    label: "Şubat",
    value: "02",
  },
  {
    label: "Mart",
    value: "03",
  },
  {
    label: "Nisan",
    value: "04",
  },
  {
    label: "Mayıs",
    value: "05",
  },
  {
    label: "Haziran",
    value: "06",
  },
  {
    label: "Temmuz",
    value: "07",
  },
  {
    label: "Ağustos",
    value: "08",
  },
  {
    label: "Eylül",
    value: "09",
  },
  {
    label: "Ekim",
    value: "10",
  },
  {
    label: "Kasım",
    value: "11",
  },
  {
    label: "Aralık",
    value: "12",
  },
];

const years = [
  {
    label: "2022",
    value: "2022",
  },
  {
    label: "2023",
    value: "2023",
  },
  {
    label: "2024",
    value: "2024",
  },
  {
    label: "2025",
    value: "2025",
  },
  {
    label: "2026",
    value: "2026",
  },
  {
    label: "2027",
    value: "2027",
  },
  {
    label: "2028",
    value: "2028",
  },
  {
    label: "2029",
    value: "2029",
  },
  {
    label: "2030",
    value: "2030",
  },
];

module.exports = {
  months,
  years,
};
